import { fieldTypes, valueTypes } from '../../../types/common/commonTypes'
import { partFields, partState } from '../../../types/part/partTypes'

export const initialPartState: partState = {
    fields: [
        {
            field: partFields.height,
            fieldType: fieldTypes.input,
            value: '',
            valueType: valueTypes.string,
            title: 'Высота, см',
            specialProps: {
                column: 2,
                borderTop: false,
            },
        },
        {
            field: partFields.width,
            fieldType: fieldTypes.input,
            value: '',
            valueType: valueTypes.string,
            title: 'Ширина, см',
            specialProps: {
                column: 2,
                borderTop: false,
            },
        },
        {
            field: partFields.length,
            fieldType: fieldTypes.input,
            value: '',
            valueType: valueTypes.string,
            title: 'Длина, см',
            specialProps: {
                column: 2,
                borderTop: false,
            },
        },
        {
            field: partFields.weight,
            fieldType: fieldTypes.input,
            value: '',
            valueType: valueTypes.string,
            title: 'Вес, кг',
            specialProps: {
                column: 2,
                borderTop: false,
            },
        },
    ],
}
